export enum Role {
    ADMIN = "1",
    USER = "2",
    LEADER = "3",
    SUPER_LEADER = "4",
    VIEWER = "5",
    GDNT_ADMIN = "6",
    GDNT_LEADER = "7",
    GDNT_USER = "8",
    STAMP_USER = "9"
}